/** Highlight palette sampled from the official LNAT Pearson sample (screenshot 6). */
export const LNAT_HIGHLIGHT_COLOR_IDS = ['yellow', 'green', 'pink', 'lightBlue', 'red'];

export const DEFAULT_LNAT_HIGHLIGHT_COLOR = 'yellow';

export const LNAT_HIGHLIGHT_SWATCHES = {
  yellow: { id: 'yellow', label: 'Yellow', hex: '#FFFF00' },
  green: { id: 'green', label: 'Green', hex: '#00FF00' },
  pink: { id: 'pink', label: 'Pink', hex: '#FF9EC8' },
  lightBlue: { id: 'lightBlue', label: 'Light blue', hex: '#5EC8FF' },
  red: { id: 'red', label: 'Red', hex: '#FF2020' },
};

/** Darker gold so yellow marks stay visible on Black on Yellow / Light Yellow bodies. */
export const LNAT_HIGHLIGHT_YELLOW_CONTRAST_HEX = '#C4A000';

export const LNAT_STRIKE_COLOR = '#333333';

export function getLnatHighlightFill(colorId, colorScheme) {
  const id = LNAT_HIGHLIGHT_SWATCHES[colorId] ? colorId : DEFAULT_LNAT_HIGHLIGHT_COLOR;
  if (
    id === 'yellow'
    && (colorScheme === 'yellow' || colorScheme === 'lightYellow')
  ) {
    return LNAT_HIGHLIGHT_YELLOW_CONTRAST_HEX;
  }
  return LNAT_HIGHLIGHT_SWATCHES[id].hex;
}
